import axios from "axios";
import qs from "qs";
import JSONbig from "json-bigint";
import {
  setCookie,
  getCookie,
  getQueryString,
} from "@/util/extends/cookieExpand";
import responseHandleNewsso from "./response-handle-newsso";
//此文件配置请求前置操作,后置操作
//若增加log可以写到此文件
import Vue from "vue";
import { getCompleteLang } from "@oppein/op-utils";

export const TOKEN_KEY = "Oauth2-AccessToken";

export let getOauth2AccessToken = () => {
  const urlToken =
    getQueryString("Oauth2-AccessToken") || getQueryString("accessToken");
  if (urlToken) {
    sessionStorage.setItem(TOKEN_KEY, urlToken);
    setCookie("Oauth2-AccessToken", urlToken, undefined, "oppein.com", "/");
  }
  return urlToken ? urlToken : getCookie("Oauth2-AccessToken");
};
/**
 * 获取请求头的语言，输出为带地区的语言，例如en-US
 * 该项目和其他地方不同，该项目内部使用的标识为不带地区的en、zh
 * @returns
 */
export let getLanguage = () => {
  let lang = getQueryString("ui");
  if (lang) {
    localStorage.setItem("orderLocaleLanguage", lang);
    return getCompleteLang(lang.toLocaleLowerCase() === "cn" ? "zh-CN" : lang);
  } else {
    lang = localStorage.getItem("orderLocaleLanguage") || "zh-CN";
    return getCompleteLang(lang.toLocaleLowerCase() === "cn" ? "zh-CN" : lang);
  }
};
axios.defaults.transformResponse = [
  function (data) {
    return JSONbig.parse(data);
  },
];
let instance = axios.create({
  // `url` is the server URL that will be used for the request
  // url: '/user',

  // `method` is the request method to be used when making the request
  method: "post", // default

  // `baseURL` will be prepended to `url` unless `url` is absolute.
  // It can be convenient to set `baseURL` for an instance of axios to pass relative URLs
  // to methods of that instance.
  // baseURL: process.env.MOCK_ON ? "/" : (process.env.ROUTER_PATH + process.env.API_PATH),

  // `transformRequest` allows changes to the request data before it is sent to the server
  // This is only applicable for request methods 'PUT', 'POST', and 'PATCH'
  // The last function in the array must return a string, an ArrayBuffer, or a Stream
  // transformRequest: [function(data) {
  // Do whatever you want to transform the data
  // console.log(data)
  // return qs.stringify(data, {arrayFormat: 'indices'});
  // return qs.stringify(data, {arrayFormat: 'brackets'});
  // }],

  // `transformResponse` allows changes to the response data to be made before
  // it is passed to then/catch
  transformResponse: [
    function (data) {
      // Do whatever you want to transform the data
      // console.log(data);
      return data;
    },
  ],

  // `headers` are custom headers to be sent
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Oauth2-AccessToken": getOauth2AccessToken(),
    "Content-Type": "application/json; charset=utf-8",
    "Accept-Language": getLanguage(),
    "OPPEIN-Accept-Language": getLanguage(),
    // 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
  },

  // `params` are the URL parameters to be sent with the request
  // Must be a plain object or a URLSearchParams object
  /*params: {
        ID: 12345
    },*/

  // `paramsSerializer` is an optional function in charge of serializing `params`
  // (e.g. https://www.npmjs.com/package/qs, http://api.jquery.com/jquery.param/)
  /*paramsSerializer: function(params) {
        return Qs.stringify(params, {arrayFormat: 'brackets'})
    },*/

  // `data` is the data to be sent as the request body
  // Only applicable for request methods 'PUT', 'POST', and 'PATCH'
  // When no `transformRequest` is set, must be of one of the following types:
  // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
  // - Browser only: FormData, File, Blob
  // - Node only: Stream
  /*data: {
        firstName: 'Fred'
    },*/

  // `timeout` specifies the number of milliseconds before the request times out.
  // If the request takes longer than `timeout`, the request will be aborted.
  timeout: process.env.ENV_NAME === "PRO" ? 300000 : 3000000,

  // `withCredentials` indicates whether or not cross-site Access-Control requests
  // should be made using credentials
  // withCredentials: false, // default
  withCredentials: true,

  // `adapter` allows custom handling of requests which makes testing easier.
  // Return a promise and supply a valid response (see [response docs](#response-api)).
  /*adapter: function (config) {
        //...
    },*/

  // `auth` indicates that HTTP Basic auth should be used, and supplies credentials.
  // This will set an `Authorization` header, overwriting any existing
  // `Authorization` custom headers you have set using `headers`.
  /*auth: {
        username: '',
        password: ''
    },*/

  // `responseType` indicates the type of data that the server will respond with
  // options are 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
  responseType: "json", // default

  // `xsrfCookieName` is the name of the cookie to use as a value for xsrf token
  // xsrfCookieName: 'XSRF-TOKEN', // default

  // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
  // xsrfHeaderName: 'X-XSRF-TOKEN', // default

  // `onUploadProgress` allows handling of progress events for uploads
  /*onUploadProgress: function (progressEvent) {
        // Do whatever you want with the native progress event
    },*/

  // `onDownloadProgress` allows handling of progress events for downloads
  /*onDownloadProgress: function (progressEvent) {
        // Do whatever you want with the native progress event
    },*/

  // `maxContentLength` defines the max size of the http response content allowed
  // maxContentLength: 2000,

  // `validateStatus` defines whether to resolve or reject the promise for a given
  // HTTP response status code. If `validateStatus` returns `true` (or is set to `null`
  // or `undefined`), the promise will be resolved; otherwise, the promise will be
  // rejected.
  /*validateStatus: function (status) {
        return status >= 200 && status < 300; // default
    },*/

  // `maxRedirects` defines the maximum number of redirects to follow in node.js.
  // If set to 0, no redirects will be followed.
  // maxRedirects: 5, // default
  maxRedirects: 0, // default

  // `httpAgent` and `httpsAgent` define a custom agent to be used when performing http
  // and https requests, respectively, in node.js. This allows to configure options like
  // `keepAlive` that are not enabled by default.
  // httpAgent: new http.Agent({ keepAlive: true }),
  // httpsAgent: new https.Agent({ keepAlive: true }),

  // 'proxy' defines the hostname and port of the proxy server
  // `auth` indicates that HTTP Basic auth should be used to connect to the proxy, and supplies credentials.
  // This will set an `Proxy-Authorization` header, overwriting any existing `Proxy-Authorization` custom headers you have set using `headers`.
  /*proxy: {
        host: '127.0.0.1',
        port: 9000,
        auth: : {
            username: 'mikeymike',
            password: 'rapunz3l'
        }
    },*/

  // `cancelToken` specifies a cancel token that can be used to cancel the request
  // (see Cancellation section below for details)
  /*cancelToken: new CancelToken(function (cancel) {
    })*/
});
export const AppCode = "CAXA";
export const SubAppCode = "CAXAPC001";
// instance.defaults.transformResponse = [ function(data) { return JSONbig.parse(data) } ]
//参考 https://www.mmxiaowu.com/article/589af8c5b21ef8e9c
//拦截发起请求时
instance.interceptors.request.use(
  (config) => {
    // if(process.env.COLLECTION_PATH){
    config.headers["SubAppCode"] = SubAppCode;
    config.headers["AppCode"] = AppCode;
    // }
    if (config.url && config.url.indexOf("doQuotationParallel") !== -1) {
      console.log("[doQuotationParallel] 请求头 Oauth2-AccessToken:", config.headers["Oauth2-AccessToken"]);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); //扶正发起请求时发生的错误并返回
  },
);
instance.interceptors.response.use(...responseHandleNewsso);
export const axiosErrorInterceptors = [
  (response) => {
    return response;
  },
  (error) => {
    // 这里我们把错误信息扶正, 后面就不需要写 catch 了
    // console.log("response error", JSON.parse(JSON.stringify(error)));
    if (
      error.code === "ECONNABORTED" &&
      error.message.indexOf("timeout") !== -1
    ) {
      new Vue().$notify({
        title: "超时提醒",
        message: "请求超时，请刷新页面",
        type: "warning",
        duration: 0,
      });
      return Promise.reject(error);
    }
    // 修改为：如果response不存在，则明确拒绝Promise
    if (!error.response) {
      return Promise.reject(new Error("Network error: No response received"));
    }
    return Promise.resolve(error.response);
  },
];
instance.interceptors.response.use(...axiosErrorInterceptors);
export default instance;



// WEBPACK FOOTER //
// ./src/api/factory.js